import Vacancies from 'components/vacancies/Vacancies';
import React from 'react';

const Vacant = () => {
  return <Vacancies />;
};

export default Vacant;
